export default __webpack_public_path__ + "assets/images/282ebc8e06c70f81b8e4c63e03410c52.png";